import React from 'react'
import { AttachmentDataWithRequiredAttachment } from '../../../../../../../../../../@types/types'
import { convertImageUrl } from '../../../../../../../../../../services/conversion/conversionServices'
import styles from './PictureCard.module.css'

interface PictureCardProps {
  attachment: AttachmentDataWithRequiredAttachment
  onClick?: () => void
}

export const PictureCard: React.FC<PictureCardProps> = ({ attachment, onClick }) => {
  if (!attachment.attachment?.url) {
    return null
  }

  const imageUrl = convertImageUrl('640', '320', attachment.attachment.url)

  return (
    <div
      className={styles.pictureCard}
      style={{
        backgroundImage: `url(${imageUrl})`,
      }}
      onClick={onClick}
    />
  )
}
